export default {"src":"/_next/static/media/privacy.3cbdfe99.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};